import { render, staticRenderFns } from "./filter-modal.vue?vue&type=template&id=96f58d24&scoped=true"
import script from "./filter-modal.vue?vue&type=script&lang=js"
export * from "./filter-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f58d24",
  null
  
)

export default component.exports